$(document).ready(function() {
  school.init();
});
var school = {
    frame_width: 0,
    frame_height: 0,
    init: function() {

        // init controls
        scrollHeader();
        school.controls();
        school.tabs.init();
        $('.matrix-block table').addClass("table table-responsive");
    $('.tlc-calendar .table').removeClass("table-responsive");
        $(".form button").addClass('btn btn-default');
    },

    controls: function() {
        $('.home-banner-image').slick({
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            centerMode: false,
            variableWidth: false,
            autoplay:true,
            dots:true,
            prevArrow: false,
            nextArrow: false,
            respondTo: "slider",
        });

        $('.gallery.carousel').slick({
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            respondTo: "slider",
            nextArrow: '<button type="button" class="gallery-right"><i class="fa fa-chevron-right"></i></button>',
            prevArrow: '<button type="button" class="gallery-left"><i class="fa fa-chevron-left"></i></button>'
        });
        $('.section-4-carousel').slick({
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            centerMode: false,
            variableWidth: false,
            autoplay:true,
            dots:false,
            prevArrow: false,
            nextArrow: false,
            respondTo: "slider",
        });

    if($('.events-page-section').length > 0){
        $.ajax({
            url: "/event?start=" + Math.floor(Date.now() / 1000),
            dataType: "json",
            success: function(events){
                var $source = $('.event-content.event-page-clone');
                var $section = $('.events-page-section');
                $.each(events, function(index,event){
                    var $clone = $source.clone(true).removeClass('event-page-clone');
                    $clone.find('.event-text .heading').text(event.title);
                    $clone.find('.event-text .event-summary').text(event.body);
                    var datestr = event.eventDateFull+' '+event.eventDate+' '+event.eventMonthFull;
                    $clone.find('.event-text .event-date').text(datestr);
                    $section.append($clone);
                });
            }
        })
    }

    // if($('.newsletters-page-section').length > 0){

    //     var year = ['2016','2017','2018','2019','2020','2021','2022'];
    //     $.ajax({
    //         url: "/newsletters_request",
    //         dataType: "json",
    //         success: function(events){
    //             var $source = $('.newsletter-content.newsletter-page-clone');
    //             var $section = $('.newsletters-page-section');
    //             $.each(events, function(index,newsletter){
    //                 if(newsletter.timestamp > '1473861600'){
    //                     var $clone = $source.clone(true).removeClass('newsletter-page-clone');
    //                     $clone.find('.newsletter-text .screenshot-image').attr('src', newsletter.thumbnail);
    //                     $clone.find('.newsletter-text .heading').text(newsletter.title);
    //                     $clone.find('.newsletter-text .newsletter-issue .newsletter-issue-value').text(newsletter.issue);
    //                     $clone.find('.newsletter-text .newsletter-date').text(newsletter.date_string);
    //                     $clone.attr('href', newsletter.link);
    //                     $section.append($clone);
    //                     console.log(newsletter.date_string);
    //                 }
    //             });
    //         }
    //     })
    // }

    if ($('.newsletters-page-section').length > 0) {
            $.ajax({
                url: "/newsletters_request",
                dataType: "json",
                success: function(events) {
                    var newsletterClone = $('<a class="newsletter-content clearfix" target="_blank"><div class="newsletter-text"><div class="image-screenshot"><img class="screenshot-image"/></div><div class="newsletter-contents"><h2 class="heading"></h2><span class="newsletter-issue">Issue: <span class="newsletter-issue-value"></span></span><span class="newsletter-date"></span></div></div></a>');
                    var yearClone = $('<div class="year-maker panel-heading"><h2 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" class="newsletter-title"></a></h2></div>');
                    var current_year = null;
                    var dayElement = null;
                    var eventCal = $('.newsletters-page-section');
                    $.each(events, function(index, newsletter) {

                       var display_year = newsletter.year;

                       if(display_year > current_year  || display_year  < current_year){
                            current_year = display_year ;
                            var newYear = yearClone.clone(true);

                            var year = display_year;
                            newYear.find('.newsletter-title').text("Newsletter - " + year);
                            dayElement = $('<div class="newsletter-block panel panel-default"></div>');
                            dayElement.append(newYear);
                            eventCal.append(dayElement);
                        }

                        var newClone = newsletterClone.clone(true);
                        newClone.find('.screenshot-image').attr('src', newsletter.thumbnail);
                        newClone.find('.heading').text(newsletter.title);
                        newClone.find('.newsletter-issue .newsletter-issue-value').text(newsletter.issue);
                        newClone.find('.newsletter-date').text(newsletter.date_string);
                        newClone.attr('href', newsletter.link);
                        // console.log(newsletter.link);
                        eventCal.append(newClone);
                        var total = newsletter.issue.length;

                        dayElement.append(newClone);

                    });

                    $('.newsletter-block').each(function(){
                        var count =  $(this).find('.newsletter-content').length;
                        $(this).find('.newsletter-title').attr('href', "#newsletter-" + count);
                        $('.newsletter-block:first').find('.newsletter-content-wrapper').addClass('in');
                        $(this).find('.newsletter-content').wrapAll('<div class="newsletter-content-wrapper panel-collapse collapse" id="newsletter-'+ count +'"><div class="panel-body"></div></div>');
                    });

                }
            });
        }
    if ($('.events-container').length > 0) {
        var post = "/event";

        $.ajax({
            url: "/event?start=" + Math.floor(Date.now() / 1000),
            dataType: "json",
            success: function(events) {
                events.sort(function(a, b) {
                    return a.start - b.start;
                })
                var today = Math.round(Date.now() / 1000);
                var eventCount = 0;
                var limit = 4;
                // loop over each event
                $.each(events, function(index, event) {

                    // stop loop at 6 events
                    if (eventCount >= limit) {
                        return false;
                    }
                    if(event.start > today ){
                       // clone event listings
                        var event_clone = $(".events-clone").find(".events-listings").clone(true);

                        // set event data on clone
                        event_clone.attr("id", event.id);
                        event_clone.find(".description").text(event.title);
                        event_clone.find(".day").text(event.eventDateFull + "  " + event.eventDate);
                        event_clone.find(".month").text(event.eventMonthFull);
                        if(event.eventStartTime != event.eventEndTime){
                            event_clone.find(".time").text(event.eventStartTime + " - " + event.eventEndTime);
                        }else{
                            event_clone.find(".time").text("All Day");
                        }
                        eventCount++;
                        // append modal to body
                        $('body').append(event.content);

                        // move clone to event wrapper
                        $('.events-container').append(event_clone);
                    }

                });

                // on event click show modal
                $(".events-listings").click(function() {

                    // get event id
                    var event_id = $(this).attr("id")

                    // show modal
                    $('#e_' + event_id).modal('show');

                });
            }
        })
    }
        $("#calendar").fullCalendar({
            events: {
                url: "/event",
            },
            displayEventTime: true,
            timezone: "Australia/Sydney",
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,basicWeek,basicDay'
            },
            editable: false,
            timeFormat: 'h(:mm)tt',
            eventClick: function(event, jsevent) {

                if(!$(jsevent.target).closest('.cal-popup').length){

                    var eventobj = $(jsevent.target).closest('.fc-event');

                    if(eventobj.find('.cal-popup').length){
                        if(!eventobj.find('.cal-popup.active').length){
                           popupadjustments(eventobj);
                        }
                        else{
                            eventobj.removeClass('popup-active');
                        }
                        eventobj.find('.cal-popup').toggleClass('active');
                    }else{
                        eventobj.append(event.popup);
                        popupadjustments(eventobj);
                        eventobj.find('.cal-popup').addClass('active');
                    }

                    $('.fc-event').not(eventobj).removeClass('popup-active');
                    $('.fc-event').not(eventobj).find('.cal-popup').removeClass('active');

                    return false;
                }
                return true;
            },
            loading: function(bool) {
                if (bool) {
                    $('#calendar').addClass('loading');
                } else {
                    $('#calendar').removeClass('loading');
                }
            }
        });
        if($('#calendar-mobile').length) {
            $('#calendar-mobile').digistormMobileCalendar({
                url: '/event',
                timezone: 'Australia/Sydney'
            });
        }

        // $('.banners').slick({
        //  arrows: false,
        // });

        // $('.carousel-mask').slick({
        //  arrows: false,
        // });
        $('.toggle-nav').click(function() {
            $(this).toggleClass("cross");
            $("body").toggleClass("nav-active");
            $("body").removeClass("nav-active-second");
        })
        // $('.gallery.lightbox').slick({
        //  slidesToShow: 8,
        //  infinite: true,
        //  speed: 600,
        //  swipeToSlide: true,
        //  centerMode: true,
        //  arrows: false
        // });

        $('.video-overlay').click(function() {
            $(this).hide();
        });

        $(".bg-stretch").find("iframe").each(function(index, frame) {

            var iframe_source = $(frame).attr("src")
            $(frame).attr("src", iframe_source + "?background=1&autoplay=1&portrait=0&title=0&loop=1&byline=0");

            school.frame_width = $(frame).outerWidth();
            school.frame_height = $(frame).outerHeight();

            var win_width = $(window).width();
            var win_height = $(window).height();

            var new_height = (school.frame_height / school.frame_width) * win_width;

            if (new_height>win_height) {

                // maximize width
                var new_height = (school.frame_height / school.frame_width) * win_width;

                $(frame).css({
                    height: new_height,
                    width: win_width
                });

            } else {

                // maximize height
                var new_width = (school.frame_width / school.frame_height) * win_height;

                $(frame).css({
                    height: win_height,
                    width: new_width
                });
            }


            // setTimeout(function() {
            //     $(frame).parent().parent().find(".video-banner").addClass("fadeout");
            // }, 5000);


        });

       $(window).resize(function() {

            $(".bg-stretch").find("iframe").each(function(index, frame) {

                var win_width = $(window).width();
                var win_height = $(window).height();

                var new_height = (school.frame_height / school.frame_width) * win_width;

                if (new_height>win_height) {

                    var new_height = (school.frame_height / school.frame_width) * win_width;

                    $(frame).css({
                        height: new_height,
                        width: win_width
                    });
                } else {
                    var new_width = (school.frame_width / school.frame_height) * win_height;

                    $(frame).css({
                        height: win_height,
                        width: new_width
                    });
                }

            });
        });
        $('.video-section').click(function() {
            $(this).hide();
        });
    },

    tabs: {
        init: function() {

            $(".tab-title").click(function(e) {
                e.preventDefault();
                $('.tab-title').removeClass("active");
                $(this).addClass("active");
                var tab_id = $(this).find("a").attr("href");
                $(tab_id).siblings().removeClass("active");
                $(tab_id).addClass("active");

            })
        }
    }

}
var $image = $('.video-thumbnailImage');
var x = $('.video-placeholder iframe');
x.autoplay= true;
var $video = x; // hide #myvideo with css

$(function(){
    $image.on('click', function(){
        $image.hide();
        $video.show();
    });
});

$('img.video-thumbnailImage').click(function(){
        var video = '<img class="slider-image" src="'+ $(this).attr('data-image') +'"><iframe frameborder="0" width="580px" height="380px" scrolling="no" src="'+ $(this).attr('data-video') +'"></iframe>';
        $(this).replaceWith(video);
        $('.btn-play').css("display","none");
});
$('.btn-play').click(function(){
        var video = '<img class="slider-image" src="'+ $(this).attr('data-image') +'"><iframe frameborder="0" width="580px" height="380px" scrolling="no" src="'+ $(this).attr('data-video') +'"></iframe>';
        $(this).replaceWith(video);
        $('.btn-play').css("display","none");
        $('.video-thumbnailImage').css("display","none");
});
$('.fb-video-image').click(function(){
    $(this).css("display","none");

                        //   <div class="fb-video fb-video-1" id="video-2{{FB_id}}"
                        // data-href="{{block.facebookVideoUrl}}"
                        // data-width="600"
                        // data-autoplay="true"
                        // data-allowfullscreen="true"></div>
    // var video = '<div class="fb-video fb-video-1" id="'+ $(this).attr('data-id') +'" data-href="'+$(this).attr('data-href')+'" data-width="600" data-autoplay="true" data-allowfullscreen="true"</div>';
    // $(this).parent('.facebook-video-wrapper').append(video);
});
// var duration = $('.fb-video').getDuration();
// console.log(duration);

$("a.scroll-down").click(function() {
    $('html, body').animate({
        scrollTop: $(".info-block").offset().top
    }, 800);
});

$( window ).resize(function() {
  if ($( window ).width() > 767){
    if ($('body').hasClass('nav-active')){
        $('body').removeClass('nav-active');
    }
    if($('.nav-toggle').hasClass('active')){
        $('.nav-toggle').removeClass('active');
    }
    if($('.first-level').hasClass('collapse-in')){
        $('.first-level').removeClass('collapse-in').addClass('collapsed');
    }
    if($('.arrow-selector').hasClass('fa-chevron-up')){
        $('.arrow-selector').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }
  }
});

// // Custom Tab Setup //

// function resetTabs(){
//     $(".tab-content > div").hide(); //Hide all content
//     $(".tabset li").attr("class",""); //Reset id's
//     $(".tabset a").attr("class",""); //Reset id's
// }

// var myUrl = window.location.href; //get URL
// var myUrlTab = myUrl.substring(myUrl.indexOf("#")); // For mywebsite.com/tabs.html#tab2, myUrlTab = #tab2
// var myUrlTabName = myUrlTab.substring(0,4); // For the above example, myUrlTabName = #tab

// $(function(){
//     $(".tab-content > div").hide(); // Initially hide all content
//     $(".tabset li:first").attr("class","active");
//     $(".tabset li:first a").attr("class","current"); // Activate first tab
//     $(".tab-content > div:first").fadeIn(); // Show first tab content

//     $(".tabset a").on("click",function(e) {
//         e.preventDefault();
//         if ($(this).attr("class") == "current"){ //detection for current tab
//          return
//         }
//         else{
//         resetTabs();
//         $(this).attr("class","current"); // Activate this
//         $(this).parent().attr("class","active"); // Activate this
//         $($(this).attr('name')).fadeIn(); // Show content for current tab
//         }
//     });

//     for (i = 1; i <= $(".tabset li").length; i++) {
//       if (myUrlTab == myUrlTabName + i) {
//           resetTabs();
//           $("a[name='"+myUrlTab+"']").attr("c","current"); // Activate url tab
//           $(myUrlTab).fadeIn(); // Show url tab content
//       }
//     }
// });

// $('.external-links-sub-box').each(function() {
//     var articles_wrapper = $(this);
//     if ($(articles_wrapper).find('li').length == 0) {
//         $(articles_wrapper).hide();
//     }
// })

$(".arrow-selector").click(function() {

    if ($(this).hasClass("fa-chevron-down")) {
        $(this).addClass('fa-chevron-up');
        $('.fa-chevron-up').parent('.first-level').addClass('collapse-in').removeClass('collapsed');
        $(this).removeClass('fa-chevron-down');
    } else {
        $(this).parent('.first-level').addClass('collapsed').removeClass('collapse-in');
        $(this).removeClass('fa-chevron-up');
        $(this).addClass('fa-chevron-down');
    }

});

$(".drop-down").hover(
  function(){ // Mouse Over
   $(this).parent().addClass("hover-nav");
  },
  function(){ // Mouse Out
    $(this).parent().removeClass("hover-nav");
  }
);

// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player = [];
function onYouTubeIframeAPIReady() {
$(".yt-player-dummy").each(function(index) {
  var id = $(this).attr("id");
    player[index+31] = new YT.Player(id, {
    height: '0',
    width: '0',
    videoId: $(this).data("video-id"),
    playerVars: {'rel': 0, 'showinfo': 0, 'modestbranding':0,'autoplay':0 },
    events: {
      'onReady': function onPlayerReady(event){
        var Duration = (player[index+31].getDuration() / 60);
        var total_time = Duration.toFixed(2);
        $("#time_2" + (index)).text(total_time);
      }
    }
  });
});
}
// function playMe() {
  $('.yt-player2').click(function(index) {
    var id = $(this).attr("id");
    player[index+21] = new YT.Player(id, {
      height: '231',
      width: '320',
      videoId: $(this).data("video-id"),
      playerVars: {'rel': 0, 'showinfo': 0, 'modestbranding':0,'autoplay':0 },
      events: {
      'onReady': onPlayerReady
      }
    });
  });
// }
function onPlayerReady(event) {
  event.target.playVideo();
}
function onPlayerStateChange(event) {
    if(event.data === 0) {
        console.log('done');
    }
}
setTimeout(function() {
    $('.yt-player-dummy').remove();
}, 5000);


function scrollHeader() {
    var scrollHeight = $(".banner-wrapper").height();
    var insidescrollHeight = $(".banner-area").height()/2;
    var windows_width = $(window).width();
    window.addEventListener('scroll', function(e){
        var distanceY = window.pageYOffset || document.documentElement.scrollTop,
        // console.log(scrollHeight);
            shrinkOn = scrollHeight,
            insideshrinkOn = insidescrollHeight,
            header = document.querySelector("header");
            if (distanceY > shrinkOn) {
                $('#header.home-header').addClass("position-fixed");
            } else {
                if ($('#header.home-header').hasClass("position-fixed")) {
                 $('#header.home-header').removeClass("position-fixed");
                }
            }
            if (distanceY > insideshrinkOn) {
                $('#header.inside-page-header').addClass("position-fixed");
            } else {
                if ($('#header.inside-page-header').hasClass("position-fixed")) {
                 $('#header.inside-page-header').removeClass("position-fixed");
                }
            }
    });

}
$( window ).resize(function() {
  if ($( window ).width() > 767){
    if ($('#header.home-header').hasClass("position-fixed")) {
         $('#header.home-header').removeClass("position-fixed");
    }
    if ($('#header.inside-page-header').hasClass("position-fixed")) {
        $('#header.inside-page-header').removeClass("position-fixed");
    }
  }
});

// var windows_height = $(window).height();
// var windows_width = $(window).width();
// var banner_height = $(".banner-wrapper").height();
// var scroll_height = banner_height-windows_height;
// console.log(scroll_height);

// $(document).ready(function() {
//     if (windows_height => banner_height){
//         $(".home-header").addClass("position-fixed");
//     }else{
//         $(".home-header").removeClass("position-fixed");
//     }
// });
// if (windows_width > 767 ){
//     $(window).scroll(function() {
//         var scroll_amount = $(window).scrollTop();
//             if (scroll_amount >= banner_height){
//                 $(".home-header").addClass("position-fixed");
//             }else{
//                if ($(".home-header").hasClass("position-fixed")){
//                     $(".home-header").removeClass("position-fixed");
//                 }
//             }
//     });
// }
function openmodal(selector){
    $(selector).addClass('modal-active');
}

function closemodal(selector){
    $(selector).removeClass('modal-active');
}

function closepopup(el){
    $(el).closest('.cal-popup').removeClass('active');
}

function popupadjustments(eventobj){
    if(eventobj.offset().left < 190){
        eventobj.find('.cal-popup').addClass('left');
    }else if(eventobj.offset().left + eventobj.width() > $(window).width() - 190 ){
        eventobj.find('.cal-popup').addClass('right');
    }
    if(eventobj.offset().top - $(window).scrollTop() < $(window).height() / 2){
        eventobj.find('.cal-popup').addClass('top');
    }else{
        eventobj.find('.cal-popup').removeClass('top');
    }
    eventobj.addClass('popup-active');
}
// prep calculator
$('.prep-calc-month').change(function() {
    var m = $(this).val();
    var y = parseInt($('.prep-calc-year').val());
    if ($('.output-p-year').length > 0) {
        $('.output-p-year').addClass('off-screen');
        $('.output-p-year7').addClass('off-screen');
        setTimeout(function() {
            $('.output-p-year').remove();
            $('.output-p-year7').remove();
            $('.remove-this').remove();
        }, 350);
    }
    setTimeout(function() {
        if (m == "1" || m == "2" || m == "3" || m == "4") {
            y+=5;
            var y7 = y+7;
            $('.prep-calc-output').append('<p class="output-p-year">Your child is due to commence for Foundation in: <span class="prep-calc-year-output">'+y+'</span></p> <br class="remove-this"> <p class="output-p-year7">Your child is due to commence for Year 7 in <span class="prep-calc-year-7-output">'+y7+'</span></p>');
        } else {
            y+=6;
            var y7 = y+7;
            $('.prep-calc-output').append('<p class="output-p-year">Your child is due to commence for Foundation in: <span class="prep-calc-year-output">'+y+'</span></p> <br class="remove-this"> <p class="output-p-year7">Your child is due to commence for Year 7 in <span class="prep-calc-year-7-output">'+y7+'</span></p>');
        }
        setTimeout(function() {
            $('.prep-calc-output p').addClass('on-screen');
        }, 100);
    }, 355);
});
$('.prep-calc-year').change(function() {
    var m = $('.prep-calc-month').val();
    var y = parseInt($(this).val());
    if ($('.output-p-year').length > 0) {
        $('.output-p-year').addClass('off-screen');
        $('.output-p-year7').addClass('off-screen');
        setTimeout(function() {
            $('.output-p-year').remove();
            $('.output-p-year7').remove();
            $('.remove-this').remove();
        }, 350);
    }
    setTimeout(function() {
        if (m == "1" || m == "2" || m == "3" || m == "4") {
            y+=5;
            var y7 = y+7;
            $('.prep-calc-output').append('<p class="output-p-year">Your child is due to commence for Foundation in: <span class="prep-calc-year-output">'+y+'</span></p> <br class="remove-this"> <p class="output-p-year7">Your child is due to commence for Year 7 in <span class="prep-calc-year-7-output">'+y7+'</span></p>');
        } else {
            y+=6;
            var y7 = y+7;
            $('.prep-calc-output').append('<p class="output-p-year">Your child is due to commence for Foundation in: <span class="prep-calc-year-output">'+y+'</span></p> <br class="remove-this"> <p class="output-p-year7">Your child is due to commence for Year 7 in <span class="prep-calc-year-7-output">'+y7+'</span></p>');
        }
        setTimeout(function() {
            $('.prep-calc-output p').addClass('on-screen');
        }, 100);
    }, 355);
});


if ($('.output-p-year').length > 0) {
    $('.prep-calc-output p').addClass('on-screen');
}

window.fbAsyncInit = function() {
  FB.init({
    appId      : '1924315874504561',
    xfbml      : true,
    version    : 'v2.5'
  });
var my_video_player = [];
FB.Event.subscribe('xfbml.ready', function(msg) {
    $(".fb-video-dummy").each(function(index) {
        var id = $(this).attr("id");
        if (msg.type === 'video' && msg.id === id) {
            my_video_player[index+41] = msg.instance;
            var myEventHandler = my_video_player[index+41].subscribe('startedPlaying', function(e) {
                var Duration = (my_video_player[index+41].getDuration() / 60);
                var total_time = Duration.toFixed(2);
                $("#time_5" + (index)).text(total_time);

            });
        }
    });
});
$(".fb-video-1").each(function(index) {
  var id = $(this).attr("id");
  var my_video_player;
    FB.Event.subscribe('xfbml.ready', function(msg) {
    if (msg.type === 'video' && msg.id === id) {
      my_video_player = msg.instance;
    }
    $('.fb-video-image').click(function(){
        $(this).css("display","none");
        my_video_player.play();
    });
  });
});
};

(function(d, s, id){
   var js, fjs = d.getElementsByTagName(s)[0];
   if (d.getElementById(id)) {return;}
   js = d.createElement(s); js.id = id;
   js.src = "//connect.facebook.net/en_US/sdk.js";
   fjs.parentNode.insertBefore(js, fjs);
 }(document, 'script', 'facebook-jssdk'));
// // });

var alertid;
var alerts;
var dismissed;
var currentalert;

function removeTags(string){
    var txt = string;
    var rex = /(<([^>]+)>)/ig;
    var newString = txt.replace(rex , "");
    return newString;
}

$('.navbar-alert').click(function(e){
    if(!$(e.target).closest('.alert-message').length && !$(e.target).hasClass('dismiss-alert') ){
        $(this).toggleClass('expanded');
    }
});
//

if ($('body').hasClass('homepage')){
    $.ajax("//eduapp.com.au/api/v4/notices.json?tk=76718b9f1134a44473f3ff074eddab645f0349d5&destination_ids[]=277").done(
    function(result){

        if(result.length){

            alerts = result;
            dismissed = Cookies.getJSON('dismissed');
            if(dismissed == null){
                dismissed = [];
            }
            alertid = result[0]['id'];
            currentalert = 0;

            getNextAlert();
        }
    });
};


function getNextAlert(){

    var isdismissed = true;
    while(isdismissed && currentalert < alerts.length){

        isdismissed = false;
        alertid = alerts[currentalert]['id'];

        for(var j = 0; j < dismissed.length; j++){
            if (dismissed[j] == alertid){
                isdismissed = true;
            }
        }
        if(!isdismissed){
            var $content = $(".navbar-alert .alert-content");
            $content.html("<div class='alert-title'>" + alerts[currentalert]['title']+ "</div>");
            var alertDesc = removeTags(alerts[currentalert]['body']);
            console.log(alertDesc);
            alertDesc = alertDesc.substring(0,120) + '... <a class="modal-link" data-toggle="modal" data-target="#alert-modal-'+alertid+'">Read more</a>';
            var $message = $("<div class='alert-message'>" + alertDesc + "</div>");
            $('.alert').find('.alert-desc .alert-desc-inner').html(alertDesc);
            $('.modal-alerts').find('.modal-title').text(alerts[currentalert]['title']);
            $('.modal-alerts').find('.alert-modal-body').html(alertDesc);
            var new_modal = '<div class="modal fade modal-alerts" id="alert-modal-'+alerts[currentalert]['id']+'" tabindex="-1" role="dialog" aria-labelledby="label" aria-hidden="true">' +
                '<div class="modal-dialog"><div class="modal-content"><div class="modal-header">' +
                '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h2 class="modal-title">'+ alerts[currentalert]['title']+'</h2></div>' +
                '<div class="modal-body"><div class="alert-modal-body">'+alerts[currentalert]['body']+'</div><ul class="alert-modal-list"></ul></div>' +
                '<div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div>';
                $('body').append(new_modal);
            for(var i = 0; i < alerts[currentalert]['attachments'].length; i++){
                if (alerts[currentalert]['attachments'][i]['type'] == 'file') {
                    var new_attachment = '<li><i class="fa fa-arrow-circle-down"></i>&nbsp;<a href="'+alerts[currentalert]['attachments'][i]['url']+'" target="_blank">'+alerts[currentalert]['attachments'][i]['file_name']+'</a></li>';
                } else if (alerts[currentalert]['attachments'][i]['type'] == 'link') {
                    var new_attachment = '<li><i class="fa fa-external-link-square"></i>&nbsp;<a href="'+alerts[currentalert]['attachments'][i]['url']+'" target="_blank">'+alerts[currentalert]['attachments'][i]['url']+'</a></li>';
                } else if (alerts[currentalert]['attachments'][i]['type'] == 'address') {
                    var new_attachment = '<li><i class="fa fa-map-marker" style="margin-left:3px"></i>&nbsp;'+alerts[currentalert]['attachments'][i]['address']+'</li>';
                }
                $('.alert-attachments ul').append(new_attachment);
                $('#alert-modal-'+alerts[currentalert]['id']).find('.alert-modal-list').append(new_attachment);
                // $('#alert-modal-'+alerts[currentalert]['id']).find('.alert-modal-list').append('<li><a href="'+alerts[currentalert]['attachments'][i]['url']+'">Read More</a></li>');
                //$message.append('<a href="'+alerts[currentalert]['attachments'][i]['url']+'">Read More</a>');
            }
            $content.append($message);
            console.log(alerts[currentalert]['body']);
            $(".navbar-alert").addClass("active");
            $('#main').addClass('alert-active');
            $('.navbar').addClass('alert-active');
            $('.mobile-nav').addClass('alert-active');
        }else{
            currentalert++;
        }
    }
}


$('.navbar-alert .dismiss-alert').click(function(e){
    $(".navbar-alert").removeClass("active");
    $('#main').removeClass('alert-active');
    $('.navbar').removeClass('alert-active');
    dismissed.push(alertid);
    Cookies.set('dismissed', dismissed);
    window.setTimeout(getNextAlert, 500);
});

$('.form').submit(function() {
    var button = $(this).find("button[type='submit']");

    button.prop('disabled',true);

    setTimeout(function() {
        button.prop('disabled',false);
   },3000);

});